import { Link } from "react-router-dom";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "最新资讯", to: "/news" },
  { label: "影视作品", to: "/works" },
  { label: "个人资料", to: "/profile" },
];

const hotTags = ["活动报道", "采访专访", "作品发布", "荣誉奖项", "幕后花絮"];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-100 mt-20">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center font-heading text-lg">
                白
              </span>
              <span className="font-heading text-lg text-background-50 tracking-wide">
                白石茉莉奈 明星动态平台
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed max-w-sm font-body">
              专注呈现白石茉莉奈的最新动态、影视作品与个人资料，以权威、丰富、结构清晰的方式，
              陪伴每一位关注她的朋友。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4 tracking-wide">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-300 hover:text-accent-400 transition-colors font-body"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4 tracking-wide">
              热门标签
            </h4>
            <div className="flex flex-wrap gap-2">
              {hotTags.map((tag) => (
                <Link
                  key={tag}
                  to={`/news?tag=${encodeURIComponent(tag)}`}
                  className="text-xs font-body px-3 py-1.5 rounded-full bg-foreground-900 text-foreground-200 hover:bg-accent-500 hover:text-foreground-950 transition-colors"
                >
                  {tag}
                </Link>
              ))}
            </div>
            <p className="text-xs text-foreground-400 mt-6 leading-relaxed font-body">
              本站为明星资讯展示平台，内容均为演示数据，仅用于信息浏览。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400 font-body">
            © 2026 白石茉莉奈 · 明星动态平台　保留所有权利
          </p>
          <p className="text-xs text-foreground-400 font-body">
            资讯 · 作品 · 个人资料 · 全站搜索
          </p>
        </div>
      </div>
    </footer>
  );
}